import React, { useState } from "react"
import InputWebinar from "../../atoms/input-webinar/input-webinar"
import CheckboxAtom from "../../../shared/components/atoms/checkbox/checkbox"
import Loader from "react-loader-spinner"
import DataPolicy from "../../../shared/components/molecules/data-policy/data-policy"
import { useForm } from "react-hook-form"
import WebinarService from "../../../shared/services/webinar"
import RegisterService from "../../../shared/services/register"
import useDocumentCountry from "../../../shared/hooks/useDocumentCountry"
import {
  V_COUNTRY,
  V_TYPE_ID,
  V_NUMBER_ID,
  V_EMAIL,
  V_CELLPHONE,
  V_NAME,
  V_LASTNAME,
  V_GENDER,
} from "../../../shared/state/constants/reactHookFormValidations"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import "./leaflet-form.scss"

const LeafletForm = props => {
  const {
    setstepState,
    identificadorEvento,
    profesiones,
    isWomenWebinar,
    isSecondStyle = false,
  } = props
  const genderOptions = [
    {
      value: "Femenino",
      label: "Femenino",
    },
    {
      value: "Masculino",
      label: "Masculino",
    },
    {
      value: "Prefiero no responder",
      label: "Prefiero no responder",
    },
  ]
  const isCo = process.env.LOCALE === "es-CO"
  const noHaveDocument = ["es-PR"]

  const [formstep, setFormStep] = useState(1)
  const [genericError, setGenericError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [disabledEmail, setDisabledEmail] = useState(false)
  const {
    countries: countryList,
    filterDocumentsType,
    removePrefix,
  } = useDocumentCountry()
  const [documentInfo, setDocumentInfo] = useState(filterDocumentsType())
  const mockOptions = profesiones.map(e => ({ value: e, label: e }))

  const filterActiveCountry = _country =>
    countryList?.filter(
      country => country?.locale === (_country || process.env.LOCALE || "es-CO")
    )?.[0]

  const [activeCountry, setActiveCounrty] = useState(filterActiveCountry())

  const {
    register,
    getValues,
    triggerValidation,
    setValue,
    errors,
    formState,
    watch,
    reset,
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      numberId: "",
    },
  })

  const loadDefaultValues = (data, payload) => {
    let countryLocale = countryList.filter(
      c => c.code === (data?.countryRegisterId || activeCountry.code)
    )[0]?.locale

    reset()
    setValue("email",payload?.email || data?.email || "", true)
    setValue(
      "cellPhone",
      removePrefix(payload?.cellPhone || data?.cellPhone || "", true)
    )
    setValue("typeId", payload?.typeId || data?.typeId || "", true)
    setValue("numberId", payload?.numberId || data?.numberId || "", true)
    setValue("country", countryLocale)
    setValue("name", data?.name || "", true)
    setValue("lastName", data?.lastName || "", true)
    setValue("gender", data?.gender || "", true)
    setDisabledEmail(true)
  }

  const onRegisterDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "ga_event_consultorio",
      category: "Eventos :: Próximo evento",
      action: `Click :: Inscripción Exitosa :: ${activeCountry.name}`,
      label: props.webinarName,
      value: "exitoso",
    })
  }

  const handleOnSubmitStepOne = e => {
    e.preventDefault()
    if (!isLoading && formState.isValid) {
      setIsLoading(true)
      const values = getValues()

      let payload = {
        ...values,
        cellPhone: activeCountry.prefix + values.cellPhone,
      }

      RegisterService.validateEmailAndCell(payload)
        .then(({ data }) => {
          setFormStep(2)
          loadDefaultValues(data, payload)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  const handleOnSubmitStepTwo = e => {
    e.preventDefault()

    if (!isLoading && formState.isValid) {
      setIsLoading(true)
      const data = getValues()
      let payload = {
        ...data,
        cellPhone: activeCountry.prefix + data.cellPhone,
        countryRegisterId: activeCountry.code,
        tycAccepted: 1,
      }

      props.checksAceptoDePoliticas?.forEach(({ idEtiqueta }) => {
        payload[idEtiqueta] = data[idEtiqueta] ? 1 : 0
      })

      WebinarService.postRegisterProspect(identificadorEvento, payload)
        .then(res => {
          if (res.status === 200) {
            onRegisterDataLayer()
            setstepState("step2")
          } else if (res.status === 400 && res.errorCode === "DEM050") {
            setGenericError({
              numberId: "El documento ya esta registrado con otra cuenta.",
            })
          } else if (res.status === 400 && res.errorCode === "DEM011") {
            setGenericError({
              cellPhone: "El celular ya esta registrado con otra cuenta.",
            })
          } else {
            setGenericError({
              general: res.userMessage || "ocurrido un error inesperado",
            })
          }
        })
        .finally(() => setIsLoading(false))
    }
  }

  const changeDocumentTypeProperties = array => {
    return array.map(({ name, value }) => ({ label: name, value: value }))
  }

  const documentsInfoChile = [
    {
      inputNumeroDeDocumento: 'Número de documento *',
      inputTipoDeDocumento: 'Tipo de documento *',
      tipoDeDocumento: [
        { name: 'RUT', value: 'RUT' }
      ]
    }
  ][0]

  const onChangeCountry = async _country => {
    let cellPhone = watch("cellPhone")
    await setActiveCounrty(await filterActiveCountry(_country))
    if( _country === 'es-CL'){
      setDocumentInfo(documentsInfoChile)
    }else{
      setDocumentInfo(filterDocumentsType(_country))
    }

    if (cellPhone && cellPhone !== "") {
      triggerValidation("cellPhone")
    }
  }

  const renderDocumentsField = () =>
    !noHaveDocument.includes(activeCountry.locale) && (
      <>
        <InputWebinar
          placeholder={documentInfo.inputTipoDeDocumento}
          type="select"
          required
          name="typeId"
          options={changeDocumentTypeProperties(documentInfo.tipoDeDocumento)}
          register={register(V_TYPE_ID)}
          error={errors.typeId?.message}
          isWomenWebinar={isWomenWebinar}
        />
        <InputWebinar
          placeholder={documentInfo.inputNumeroDeDocumento}
          name="numberId"
          register={register(V_NUMBER_ID)}
          error={errors.numberId?.message || genericError?.numberId}
          isWomenWebinar={isWomenWebinar}
          onChange={() => {
            genericError?.numberId && setGenericError()
          }}
        />
      </>
    )

  const MailField = (
    <InputWebinar
      placeholder="Correo electrónico*"
      name="email"
      error={errors.email?.message || ""}
      isWomenWebinar={isWomenWebinar}
      disabled={disabledEmail}
      register={register({ ...V_EMAIL })}
    />
  )

  return (
    <form
      className={isSecondStyle ? "f-leaflet-form--secondary" : "f-leaflet-form"}
      onSubmit={formstep === 1 ? handleOnSubmitStepOne : handleOnSubmitStepTwo}
    >
      {formstep === 1 && (
        <div className="f-leaflet-form__inputs-group f-leaflet-form__inputs-group--step1">
          {isCo && (
            <>
              <InputWebinar
                placeholder="País*"
                type="select"
                required
                isWomenWebinar={isWomenWebinar}
                name="country"
                register={register(V_COUNTRY)}
                error={errors.country?.message}
                options={changeDocumentTypeProperties(countryList)}
                onChange={onChangeCountry}
              />

              {MailField}
            </>
          )}

          {renderDocumentsField()}

          {!isCo && MailField}

          <InputWebinar
            placeholder="Celular*"
            name="cellPhone"
            register={register({
              ...V_CELLPHONE,
              minLength: {
                value: activeCountry.cellDig,
                message: `Un número celular debe tener ${activeCountry.cellDig} dígitos.`,
              },
              maxLength: {
                value: activeCountry.cellDig,
                message: `Un número celular debe tener ${activeCountry.cellDig} dígitos.`,
              },
            })}
            onChange={() => {
              triggerValidation("cellPhone")
              genericError?.cellPhone && setGenericError()
            }}
            error={errors.cellPhone?.message || genericError?.cellPhone}
            isWomenWebinar={isWomenWebinar}
          />
        </div>
      )}

      {formstep === 2 && (
        <>
          <div className="f-leaflet-form__inputs-group">
            <InputWebinar
              placeholder="Nombres*"
              name="name"
              register={register(V_NAME)}
              error={errors?.name?.message}
              isWomenWebinar={isWomenWebinar}
            />
            <InputWebinar
              placeholder="Apellidos*"
              name="lastName"
              register={register(V_LASTNAME)}
              error={errors.lastName?.message}
              isWomenWebinar={isWomenWebinar}
            />
            {isCo && (
              <InputWebinar
                placeholder="País*"
                type="select"
                required
                isWomenWebinar={isWomenWebinar}
                name="country"
                register={register(V_COUNTRY)}
                error={errors.country?.message}
                options={changeDocumentTypeProperties(countryList)}
                onChange={onChangeCountry}
              />
            )}
            {renderDocumentsField()}

            {MailField}

            <InputWebinar
              placeholder="Celular*"
              name="cellPhone"
              register={register({
                ...V_CELLPHONE,
                minLength: {
                  value: activeCountry.cellDig,
                  message: `Un número celular debe tener ${activeCountry.cellDig} dígitos.`,
                },
                maxLength: {
                  value: activeCountry.cellDig,
                  message: `Un número celular debe tener ${activeCountry.cellDig} dígitos.`,
                },
              })}
              onChange={() => genericError?.cellPhone && setGenericError()}
              error={errors.cellPhone?.message || genericError?.cellPhone}
              isWomenWebinar={isWomenWebinar}
            />

            <InputWebinar
              placeholder="Género"
              type="select"
              required
              options={genderOptions}
              name="gender"
              register={register(V_GENDER)}
              error={errors?.gender?.message}
              isWomenWebinar={isWomenWebinar}
            />

            {isWomenWebinar && (
              <InputWebinar
                label="Ocupación o Profesión"
                placeholder="Selecciona una opción"
                type="select"
                required
                name="profession"
                register={register()}
                errors={errors.profession?.message}
                options={mockOptions}
                isWomenWebinar={isWomenWebinar}
              />
            )}
          </div>
          <br />

          <div className="f-form-row-group">
            {props.checksAceptoDePoliticas?.map(
              ({ idEtiqueta, informacinPrincipal }, index) => {
                return (
                  <CheckboxAtom
                    key={index}
                    errors={errors}
                    name={idEtiqueta}
                    showMessageError={false}
                    register={register({
                      required: "Debes seleccionar este campo",
                    })}
                    onChange={() => triggerValidation(idEtiqueta)}
                    label={
                      <>{documentToReactComponents(informacinPrincipal.json)}</>
                    }
                  />
                )
              }
            )}
          </div>

          <div className="f-data-policy-container">
            <DataPolicy />
          </div>
        </>
      )}

      {genericError?.general && (
        <span class="f-text f-error">{genericError?.general}</span>
      )}

      {!isLoading ? (
        <button
          className={
            isWomenWebinar
              ? "f-leaflet-form-submit f-leaflet-form-submit--women"
              : "f-leaflet-form-submit"
          }
          disabled={!formState.isValid || genericError}
          type="submit"
        >
          {formstep === 1 ? "CONTINUAR" : "ENVIAR"}
        </button>
      ) : (
        <div className="f-loader-container">
          <Loader type="Oval" color="#003784" height={50} width={50} />
        </div>
      )}
    </form>
  )
}

export default LeafletForm
